import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import BrandMark from "@/components/BrandMark";

export default function LegalLayout({ title, kicker, children }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-[100dvh] bg-[#FBF9F6] grain">
      <div className="max-w-2xl mx-auto px-6 pt-12 pb-8">
        <button onClick={() => navigate(-1)} className="mb-4 flex items-center gap-2 text-sm font-[Manrope] text-stone-600">
          <ChevronLeft size={16} /> back
        </button>
        <BrandMark className="mb-6" to="/home" />
        <div className="text-[10px] font-[Manrope] font-bold tracking-[0.3em] uppercase text-[#6B7A54] mb-2">{kicker}</div>
        <h1 className="font-[Cormorant_Garamond] text-4xl sm:text-5xl leading-tight tracking-tight text-stone-900 mb-6">
          {title}
        </h1>        <div className="prose-legal font-[Manrope] text-stone-700 text-[15px] leading-relaxed space-y-5">
          {children}
        </div>
        <div className="mt-12 text-xs font-[Manrope] text-stone-500 flex flex-wrap gap-x-3 gap-y-1">
          <Link to="/privacy" className="hover:text-[#6B7A54]">Privacy</Link>
          <span>·</span>
          <Link to="/terms" className="hover:text-[#6B7A54]">Terms</Link>
          <span>·</span>
          <Link to="/refunds" className="hover:text-[#6B7A54]">Refunds</Link>
          <span>·</span>
          <Link to="/contact" className="hover:text-[#6B7A54]">Contact</Link>
          <span>·</span>
          <span>© 2026 Aynora</span>
        </div>
      </div>
    </div>
  );
}

export const H2 = ({ children }) => (
  <h2 className="font-[Cormorant_Garamond] italic text-2xl text-stone-900 mt-8 mb-2">{children}</h2>
);
